import { toggleCartActionCreator } from 'src/state/cart/action-creators/toggle-cart-action-creator';
import { setUpgradesInCart } from 'src/state/cart/cart-slice';
import { AppDispatch, RootState } from 'src/state/types';

export const addUpgradesToCartActionCreator =
  (upgrade: string[]) => (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(setUpgradesInCart(upgrade));
    toggleCartActionCreator(true)(dispatch, getState);
  };
